import { BookOpenIcon, FaceWinkIcon, FlagIcon, RecordingIcon, SubtitlesDisabledIcon, UserIcon } from '@braskai/icons';

import { Icon, Typography, useTheme } from '@mui/material';

import { SFeatureBlock, SGrid } from './styled';

const FEATURES = [
  {
    label: 'VoiceClone in 29 languages',
    icon: RecordingIcon,
  },
  {
    label: 'Lip-Sync for best-in-class localization',
    icon: FaceWinkIcon,
  },
  {
    label: 'Multi-speaker dubbing support',
    icon: UserIcon,
  },
  {
    label: 'Translation to 130+ supported languages',
    icon: FlagIcon,
  },
  {
    label: 'Translation dictionary',
    icon: BookOpenIcon,
  },
  {
    label: 'AI-generated captions',
    icon: SubtitlesDisabledIcon,
  },
];

export const FeaturesBlock = () => {
  const { palette } = useTheme();
  return (
    <SGrid>
      {FEATURES.map(({ label, icon }) => (
        <SFeatureBlock key={label}>
          <Icon component={icon} />
          <Typography color={palette.text.primary} variant="body-2-md">
            {label}
          </Typography>
        </SFeatureBlock>
      ))}
    </SGrid>
  );
};
